import React from 'react';
import { Building2, Mail, MapPin, ExternalLink } from 'lucide-react';
import './Stormbyte.css';

export default function StormbytePage(): React.ReactElement {
  return (
    <div className="stormbyte-page">
      <div className="stormbyte-container">
        <header className="stormbyte-header">
          <h1 className="stormbyte-title">Stormbyte LLC</h1>
          <p className="stormbyte-tagline">Building location-based social experiences</p>
        </header>

        <section className="stormbyte-section">
          <h2>About Us</h2>
          <p>
            Stormbyte LLC is the company behind <strong>Hereabout</strong>, a revolutionary
            location-based social media platform. We're building the future of how people
            connect with places and communities around the world.
          </p>
          <p>
            Founded with a mission to turn every location into a living, breathing social canvas,
            we combine cutting-edge technology with user-centric design to create meaningful
            connections between people and places.
          </p>
        </section>

        <section className="stormbyte-section">
          <h2>Our Products</h2>
          <div className="product-card">
            <h3>Hereabout</h3>
            <p>
              A map-based social platform that lets you drop photos, videos, and live streams
              directly onto any spot on the map. Create Layer communities, discover local content,
              and connect with people in real locations.
            </p>
            <a href="/download" className="product-link">
              <ExternalLink size={16} />
              Learn More
            </a>
          </div>
        </section>

        <section className="stormbyte-section">
          <h2>Contact Information</h2>

          <div className="info-grid">
            <div className="info-card">
              <div className="info-icon">
                <Building2 size={32} color="#dc2626" />
              </div>
              <h3>Company Details</h3>
              <p><strong>Legal Name:</strong> Stormbyte LLC</p>
              <p><strong>Type:</strong> Limited Liability Company</p>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <Mail size={32} color="#dc2626" />
              </div>
              <h3>Contact</h3>
              <p><strong>Email:</strong></p>
              <p>
                <a href="mailto:engineering@stormbyte.dev">
                  engineering@stormbyte.dev
                </a>
              </p>
              <p className="contact-note">For all inquiries, support, and business matters</p>
            </div>
          </div>

          <div className="business-hours">
            <h3>Business Hours</h3>
            <p>Monday - Friday: 9:00 AM - 5:00 PM EST</p>
            <p>Response time: Within 48 hours</p>
          </div>
        </section>

        <section className="stormbyte-section">
          <h2>Legal & Policies</h2>
          <div className="links-grid">
            <a href="/privacy" className="policy-link">
              Privacy Policy
            </a>
            <a href="/terms" className="policy-link">
              Terms of Service
            </a>
            <a href="/delete-account" className="policy-link">
              Delete Account
            </a>
          </div>
        </section>

        <footer className="stormbyte-footer">
          <p>© 2025 Stormbyte LLC — All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}
